"use strict";
exports.__esModule = true;
exports.ClerkProvider = void 0;
var tslib_1 = require("tslib");
var clerk_react_1 = require("@clerk/clerk-react");
var router_1 = require("next/router");
var react_1 = tslib_1.__importDefault(require("react"));
tslib_1.__exportStar(require("@clerk/clerk-react"), exports);
var NO_FRONTEND_API_ERR = 'The NEXT_PUBLIC_CLERK_FRONTEND_API environment variable must be set to use the ClerkProvider component.';
function ClerkProvider(_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    // @ts-expect-error
    // Allow for overrides without making the type public
    var frontendApi = rest.frontendApi, __clerk_ssr_state = rest.__clerk_ssr_state, clerkJSUrl = rest.clerkJSUrl, restProps = tslib_1.__rest(rest, ["frontendApi", "__clerk_ssr_state", "clerkJSUrl"]);
    var push = (0, router_1.useRouter)().push;
    if (frontendApi == undefined && !process.env.NEXT_PUBLIC_CLERK_FRONTEND_API) {
        throw Error(NO_FRONTEND_API_ERR);
    }
    clerk_react_1.ClerkProvider.displayName = 'ReactClerkProvider';
    return (react_1["default"].createElement(clerk_react_1.ClerkProvider, tslib_1.__assign({ frontendApi: frontendApi || process.env.NEXT_PUBLIC_CLERK_FRONTEND_API, clerkJSUrl: clerkJSUrl || process.env.NEXT_PUBLIC_CLERK_JS, navigate: function (to) { return push(to); }, initialState: __clerk_ssr_state }, restProps), children));
}
exports.ClerkProvider = ClerkProvider;
//# sourceMappingURL=index.js.map